import React from 'react'
import styled from 'styled-components'
import { AppBar, Box, Button, Grid, Fade, Container, Divider, Hidden } from '@material-ui/core'
import { centerContentOnMobile } from '../../styles/media-queries'
import colors from '../../shared/constants/colors'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import ParoTips from './ParoTips'
import { useOnboarding } from '../../contexts/OnboardingContext'
import CancelIcon from '@material-ui/icons/Cancel'
import Loader from '../Loader'
import AlertSnackbar from '../../_global/Snackbar'
import HelpIcon from '@material-ui/icons/Help'
import { useAuth0 } from '../../contexts/Auth0Context'

const TABS = [
  { label: 'contact info' },
  { label: 'primary role' },
  { label: 'education' },
  { label: 'experience' },
  { label: 'preferences' },
  { label: 'your pitch' },
  { label: 'review' },
]

const ParoLogo = styled.img`
  height: 14px;
`

const StyledTabs = styled(({ ...rest }) => (
  <Tabs classes={{ indicator: 'indicator' }} {...rest} TabIndicatorProps={{ children: <div /> }} />
))`
  .indicator {
    background-color: transparent;
    display: flex;
    justify-content: center;
    padding: 10px 0px;
    & > div {
      background-color: ${colors.paroRosegold};
      height: 2px;
      max-width: 80px;
      width: 100%;
    }
  }
`

const TopAppBar = styled(AppBar)`
  background-color: ${colors.backgroundGray};
`

const ChildrenBox = styled(Box)`
  position: relative;
  top: 0px;
  @media screen and (min-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {
    top: 140px;
  }
`

const getFormstackRouteForDomain = (domain: string = '') => {
  const config = {
    "https://app.paro.io": 'https://paroio.formstack.com/forms/freelancer_registration_prod_2023',
    "https://app.paroqa.io": 'https://paroio.formstack.com/forms/freelancer_registration_qa_e2e',
  }

  const defaultUrl = 'https://paroio.formstack.com/forms/freelancer_registration_dev_e2e'
  console.log(domain)
  return config[domain] || defaultUrl;
}

const OnboardingLayout = ({ children }) => {
  const {
    handleLogout,
    step,
    isLoading,
    currentExpert: { onboardingStep },
  } = useOnboarding()
  const { user: { user_metadata }} = useAuth0()


  const mobileCenterStyles = centerContentOnMobile()

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" style={{ height: '100vh' }}>
        <Loader style={{ color: colors.paroBlack }} />
      </Box>
    )
  }
  if (onboardingStep >= 0) {
    const savedFormUrl = user_metadata.formstack_url;
    window.location.href = savedFormUrl || getFormstackRouteForDomain(process.env.REACT_APP_PARO_APP_URL)
    return (
      <Box display="flex" justifyContent="center" style={{ height: '100vh' }}>
        <Loader style={{ color: colors.paroBlack }} />
      </Box>
    )
  }
  let stepNumber = step ? step : 0
  if (stepNumber > 3) {
    // ignoring accomplishments step (step = 4)
    stepNumber = stepNumber - 1
  }

  return (
    <>
      <TopAppBar elevation={0} position="fixed" className={mobileCenterStyles.root}>
        <Box py={0} pl={4}>
          <Grid container justify="space-between" alignItems="center">
            <Grid item>
              <a href="https://paro.io/">
                <ParoLogo src="https://paro.ai/image/PARO_logo.png" alt={'Paro Logo'} />
              </a>
            </Grid>

            <Grid item>
              <AlertSnackbar
                alertMessage={'Email address copied to clipboard'}
                alertStyle={{ backgroundColor: `${colors.paroBlack}` }}
                buttonContent={'Email for help'}
                buttonIcon={<HelpIcon />}
                copyContent={'talent@paro.io'}
              />
              <Button onClick={handleLogout} startIcon={<CancelIcon />} color="primary">
                Save and Exit
              </Button>
            </Grid>
          </Grid>
        </Box>

        <Hidden smDown>
          <Box style={{ backgroundColor: '#f5efee' }} width={1}>
            <StyledTabs value={stepNumber} variant="scrollable" scrollButtons="off">
              {TABS.map((tab, index) => (
                <Tab key={index} label={tab.label} disableRipple style={{ textTransform: 'capitalize' }} />
              ))}
            </StyledTabs>
          </Box>
        </Hidden>
      </TopAppBar>

      <ChildrenBox>
        <Container maxWidth="lg">
          <Fade in={true} timeout={700}>
            <Box mt={{ xs: '15', sm: '15', md: '5', lg: '5', xl: '5' }}>
              <Grid container>
                {/* TODO For Service Line/Primary Role only */}
                <Grid item xs={12} md={[1].includes(step) ? 12 : 8}>
                  <Hidden only={['md', 'lg', 'xl']}>
                    <Box px={0}>{children}</Box>
                  </Hidden>
                  <Hidden only={['xs', 'sm']}>
                    <Box px={6}>{children}</Box>
                  </Hidden>
                </Grid>
                <Hidden mdUp>
                  <Grid item xs={12}>
                    <Box py={3}>
                      <Divider />
                    </Box>
                  </Grid>
                </Hidden>
                {/* TODO For Service Line/Primary Role only */}
                <Hidden xsUp={[1].includes(step)}>
                  <Grid item xs={12} md={4}>
                    <Box px={4} py={3} border={1} borderColor="grey.300" borderRadius="borderRadius">
                      <ParoTips step={step} />
                    </Box>
                  </Grid>
                </Hidden>
              </Grid>
            </Box>
          </Fade>
        </Container>
      </ChildrenBox>
    </>
  )
}

export default OnboardingLayout
